import useAjax from "@apis/useAjax";
import { useCallback } from "react";
import useShowPDF from "@util/hook/useShowPDF";
import { checkResponse } from "@apis/utils";
import {
	GET_DOC_MEMBERSHIP_OPTIONS_API,
	GET_DOC_MEMBERSHIP_HISTORY_API,
	GET_DOC_MEMBERSHIP_ID_API,
	POST_DOC_MEMBERSHIP_ID_API,
	DELETE_DOC_MEMBERSHIP_ID_API,
	POST_DOC_MEMBERSHIP_RANGE_FEE_API,
	GET_DOC_MEMBERSHIP_TEMPORARY_API,
	POST_DOC_MEMBERSHIP_TEMPORARY_API,
	DELETE_DOC_MEMBERSHIP_TEMPORARY_API,
	GET_DOC_MEMBERSHIP_TEMPLATE_PDF_API,
	GET_DOC_MEMBERSHIP_CONTRACTS_CONTRACTIDID_CAN_DELETE_API,
} from "@apis/apiPath";
import { isEmpty } from "@util/utils";

const useDocMembershipApi = () => {
	const Ajax = useAjax();
	const showPDF = useShowPDF();

	// 取得入會申請書的下拉式選單
	const getDocMembershipOptionApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員歷史紀錄(包含暫存)
	const getDocMembershipHistoryApi = useCallback(
		async params => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_HISTORY_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得入會會籍申請書內容
	const getDocMembershipApi = useCallback(
		async (contractID, params) => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_ID_API(contractID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 新增/重填入會合約
	const postDocMembershipApi = useCallback(
		async (contractID = 0, parameters) => {
			const resp = await Ajax.post(POST_DOC_MEMBERSHIP_ID_API(contractID), parameters);
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除入會申請書
	const deleteDocMembershipApi = useCallback(
		async (params, contractID) => {
			const resp = await Ajax.delete(DELETE_DOC_MEMBERSHIP_ID_API(contractID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 依輸入的內容重新計算日期及金額結果
	const postDocMembershipRangeFeeApi = useCallback(
		async parameters => {
			const resp = await Ajax.post(POST_DOC_MEMBERSHIP_RANGE_FEE_API, parameters);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 確認來源對象是否有暫存合約
	const getDocMembershipTemporaryApi = useCallback(
		async params => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_TEMPORARY_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 暫存入會申請書合約
	const postDocMembershipTemporaryApi = useCallback(
		async parameters => {
			const resp = await Ajax.post(POST_DOC_MEMBERSHIP_TEMPORARY_API, parameters);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除來源對象的暫存合約
	const deleteDocMembershipTemporaryApi = useCallback(
		async parameters => {
			const resp = await Ajax.delete(DELETE_DOC_MEMBERSHIP_TEMPORARY_API, parameters);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 檢查是否可以刪除 正式文書
	const getCheckDocMembershipCanDeleteApi = useCallback(
		async contractID => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_CONTRACTS_CONTRACTIDID_CAN_DELETE_API(contractID));
			return checkResponse(resp);
		},
		// eslint-disable-next-line
		[]
	);

	// 下載空白PDF文件
	const getDocMembershipTemplatePDFApi = useCallback(
		async () => {
			showPDF({
				open: true,
				pdfUrl: GET_DOC_MEMBERSHIP_TEMPLATE_PDF_API,
			});
		},
		// eslint-disable-next-line
		[]
	);

	// 下載合約申請書(非空白)
	const getDocMembershipPDFApi = useCallback(
		async contractUrl => {
			showPDF({
				open: true,
				pdfUrl: contractUrl,
			});
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getDocMembershipOptionApi,
		getDocMembershipHistoryApi,
		getDocMembershipApi,
		postDocMembershipApi,
		deleteDocMembershipApi,
		postDocMembershipRangeFeeApi,
		getDocMembershipTemporaryApi,
		postDocMembershipTemporaryApi,
		deleteDocMembershipTemporaryApi,
		getDocMembershipTemplatePDFApi,
		getDocMembershipPDFApi,
		getCheckDocMembershipCanDeleteApi,
	};
};

export default useDocMembershipApi;
